import EventBus from '@/utils/eventBus'
import { PipeHttp } from './PipeHttp'

const CACHE_KEY_HEADER = 'x-hkld-disk-cache'

export class CustomHttp extends PipeHttp {
  constructor (...args) {
    super(...args)
    this.silent = this.genProcess(async ({ metaData }, next) => {
      if (metaData) return next()
      EventBus.emit('module_loading_startLoading')
      try {
        await next()
      } catch (err) {
        throw err
      } finally {
        EventBus.emit('module_loading_stopLoading')
      }
    })
    this.diskCache = this.genProcess(async ({ method, metaData, args }, next) => {
      if (method !== 'get' || typeof metaData !== 'string' || metaData.length === 0) return next()
      const opts = args[args.length - 1]
      const { headers = {}, ...othersArgs } = opts
      Object.assign(headers, { [CACHE_KEY_HEADER]: metaData })
      Object.assign(othersArgs, { headers })
      args[args.length - 1] = othersArgs
      return next()
    })
  }
}
